var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repeat-option-set repeat-option-set-summary-read-only" },
    [
      _c("div", {
        staticClass:
          "repeat-option-set-summary-read-only__icon icon icon-repeat"
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "repeat-option-set-summary-read-only__caption" },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm._f("formatRecurrenceRule")(_vm.recurrenceRule, _vm.locale)
              ) +
              "\n\t"
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }